import React from "react";

import { useZoneProjectsRetrieval } from "@planzone/view-models";
import { zoneProjectsRetrievalFilter } from "@planzone/dto";
import { ScrollPane } from "@common/scrollPane";
import { Props } from "./types";
import { Project } from "./project";
import styles from "./styles.scss";

function Projects({ zone }: Props) {
  const filter = {
    ...zoneProjectsRetrievalFilter,
    limit: 20,
    isSortedByJoinedProject: true,
    isOpen: true,
    isSortedAlphabetically: true,
  };
  const { callCount, isRequestPending, projects, retrieveZoneProjects } =
    useZoneProjectsRetrieval(zone, filter);

  React.useEffect(() => {
    callCount === 0 &&
      !isRequestPending &&
      retrieveZoneProjects({ zone, filter });
  }, [callCount, filter, isRequestPending]);

  return (
    <div className={styles.projects}>
      <ScrollPane>
        <ul className={styles.projectList}>
          {projects.map((project) => (
            <li key={project.uuid}>
              <Project project={project} />
            </li>
          ))}
        </ul>
      </ScrollPane>
    </div>
  );
}

export { Projects };
